export const UsersForm = [
    {
        "className": "full-width",
        "fieldGroup": [
            {
                "key": "firstName",
                "className": "third-width pr-xl-1",
                "type": "input",
                "templateOptions": {
                    "type": "text",
                    "label": "First Name",
                    "placeholder": "First Name",
                    "required": true
                }
            },
            {
                "key": "middleName",
                "className": "third-width px-xl-3",
                "type": "input",
                "templateOptions": {
                    "type": "text",
                    "label": "Middle Name",
                    "placeholder": "Middle Name",
                    "required": false
                }
            },
            {
                "key": "surname",
                "className": "third-width pl-xl-3",
                "type": "input",
                "templateOptions": {
                    "type": "text",
                    "label": "Last Name",
                    "placeholder": "Last Name",
                    "required": true
                }
            },
        ],
    },
    {
        "className": "full-width py-xl-2",
        "fieldGroup": [
            {
                "key": "organizationName",
                "className": "third-width pr-xl-2",
                "type": "input",
                "templateOptions": {
                    "type": "text",
                    "label": "Organization",
                    "placeholder": "Organization",
                    "required": true
                }
            },
            {
                "key": "userEmail",
                "type": "input",
                "className": "third-width px-xl-3",
                "templateOptions": {
                    "attributes": {
                        "autofocus": '',
                        "autocomplete": "off",
                    },
                    "type": "email",
                    "label": "Email",
                    "pattern": ".+@.+..+",
                    "placeholder": "Email address",
                    "required": true
                }
            },
            {
                "key": "phoneNumber",
                "type": "input",
                "className": "third-width pl-xl-3",
                "templateOptions": {
                    "attributes": {
                        "autofocus": '',
                        "autocomplete": "off",
                    },
                    "type": "phoneNumber",
                    "label": "Phone No.",
                    "placeholder": "Enter user phone number",
                    "required": false
                }
            },
        ],
    },
    {
        "className": "full-width py-xl-2",
        "fieldGroup": [
            {
                "key": "password",
                "type": "input",
                "className": "half-width pr-xl-3 less-margin",
                "templateOptions": {
                    "attributes": {
                        "autocomplete": "off",
                    },
                    "type": "password",
                    "label": "Password",
                    "minLength": 4,
                    "placeholder": "Password",
                    "required": true
                }
            },
            {
                "key": "confirm_password",
                "type": "input",
                "className": "half-width pl-xl-3 less-margin",
                "templateOptions": {
                    "attributes": {
                        "autocomplete": "off",
                    },
                    "type": "password",
                    "label": "Confirm Password",
                    "minLength": 4,
                    "placeholder": "Confirm Password",
                    "required": true
                }
            },
        ],
    },
    {
        "className": "full-width",
        "fieldGroup": [
            {
                "key": "countyId",
                "type": "select",
                "className": "half-width",
                "templateOptions": {
                    "bindLabel": "countyName",
                    "bindValue": "countyId",
                    "label": "Assign County*",
                    "optionsResource": "counties",
                    "searchable": true,
                    "multiple": false,
                    "hideSelected": true,
                    "closeOnSelect": true,
                    "required": false
                }
            },
            {
                "key": "rolesToBeAssigned",
                "type": "select",
                "className": "half-width",
                "templateOptions": {
                    "bindLabel": "roleDescription",
                    "label": "User roles*",
                    "optionsResource": "roles",
                    "searchable": false,
                    "multiple": true,
                    "hideSelected": true,
                    "closeOnSelect": true,
                    "required": true
                }
            },
        ],
    },
];

export const UsersUpdateForm = [
    {
        "className": "full-width",
        "fieldGroup": [
            {
                "key": "firstName",
                "className": "third-width pr-xl-1",
                "type": "input",
                "templateOptions": {
                    "type": "text",
                    "label": "First Name",
                    "placeholder": "First Name",
                    "required": true
                }
            },
            {
                "key": "middleName",
                "className": "third-width px-xl-3",
                "type": "input",
                "templateOptions": {
                    "type": "text",
                    "label": "Middle Name",
                    "placeholder": "Middle Name",
                    "required": false
                }
            },
            {
                "key": "surname",
                "className": "third-width pl-xl-3",
                "type": "input",
                "templateOptions": {
                    "type": "text",
                    "label": "Last Name",
                    "placeholder": "Last Name",
                    "required": true
                }
            },
        ],
    },
    {
        "className": "full-width py-xl-2",
        "fieldGroup": [
            {
                "key": "organizationName",
                "className": "half-width pr-xl-3",
                "type": "input",
                "templateOptions": {
                    "type": "text",
                    "label": "Organization",
                    "placeholder": "Organization",
                    "required": true
                }
            },
            // {
            //     "key": "email",
            //     "type": "input",
            //     "className": "third-width px-xl-3",
            //     "templateOptions": {
            //         "attributes": {
            //             "autofocus": '',
            //             "autocomplete": "off",
            //         },
            //         "type": "email",
            //         "label": "Email",
            //         "pattern": ".+@.+..+",
            //         "placeholder": "Email address",
            //         "required": true
            //     }
            // },
            {
                "key": "phoneNumber",
                "type": "input",
                "className": "half-width pl-xl-3",
                "templateOptions": {
                    "attributes": {
                        "autofocus": '',
                        "autocomplete": "off",
                    },
                    "type": "phoneNumber",
                    "label": "Phone No.",
                    "placeholder": "Enter user phone number",
                    "required": false
                }
            },
        ],
    },
    // {
    //     "className": "full-width py-xl-2",
    //     "fieldGroup": [
    //         {
    //             "key": "password",
    //             "type": "input",
    //             "className": "half-width pr-xl-3 less-margin",
    //             "templateOptions": {
    //                 "attributes": {
    //                     "autocomplete": "off",
    //                 },
    //                 "type": "password",
    //                 "label": "Password",
    //                 "minLength": 4,
    //                 "placeholder": "Password",
    //                 "required": true
    //             }
    //         },
    //         {
    //             "key": "confirm_password",
    //             "type": "input",
    //             "className": "half-width pl-xl-3 less-margin",
    //             "templateOptions": {
    //                 "attributes": {
    //                     "autocomplete": "off",
    //                 },
    //                 "type": "password",
    //                 "label": "Confirm Password",
    //                 "minLength": 4,
    //                 "placeholder": "Confirm Password",
    //                 "required": true
    //             }
    //         },
    //     ],
    // },
    {
        "className": "full-width",
        "fieldGroup": [
            {
                "key": "countyId",
                "type": "select",
                "className": "half-width",
                "templateOptions": {
                    "bindLabel": "countyName",
                    "bindValue": "countyId",
                    "label": "Assign County*",
                    "optionsResource": "counties",
                    "searchable": true,
                    "multiple": false,
                    "hideSelected": true,
                    "closeOnSelect": true,
                    "required": false
                }
            },
            {
                "key": "userRoles",
                "type": "select",
                "className": "half-width",
                "templateOptions": {
                    "bindLabel": "roleDescription",
                    "label": "User roles*",
                    "optionsResource": "roles",
                    "searchable": false,
                    "multiple": true,
                    "hideSelected": true,
                    "closeOnSelect": true,
                    "required": true
                }
            },
        ],
    },
];